import React from 'react';
import Buttonbar from './Buttonbar';

const highlight_style = {
  backgroundColor: '#FFF59D',
  paddingLeft: '5px',
  marginLeft: '-5px',
};

export default function Records ({ loading, records, handleButton, titleStyle, hiddenFields=[], selectorMode=false }) {
  if(!(Array.isArray(records) && records.length > 0)){
    return null;
  }

  return (
    <div className="records-wrapper">
      {records.map((record, index) =>
        <div className="record" key={"record_"+record.id+record.label} style={record.highlighted ? highlight_style : {}}>
          <div>
          {record.lbuttonbar && (
            <Buttonbar loading={loading} selectorMode={selectorMode} hiddenFields={hiddenFields} buttonbar={record.lbuttonbar} handleButton={handleButton} uniqueID={record.id+record.label+index} />
          )}
            <abbr title={record.hovertext} className="record-title" style={titleStyle}>
              <span className={record.class}>{record.label}</span>
            </abbr>
          {record.buttonbar && (
            <Buttonbar loading={loading} selectorMode={selectorMode} hiddenFields={hiddenFields} buttonbar={record.buttonbar} handleButton={handleButton} uniqueID={record.id+record.label+index} />
          )}
          </div>
          {record.details && (
            <pre className="details">{record.details}</pre>
          )}
        </div>
      )}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/Common/Records.js